const BRIGHTCOVE_ERROR_BASE = 0x0d00;
export const BrightcoveErrorCodes = Object.freeze({
  /**
   * Indicates VMAP document retrieval failure.
   */
  VMAP_DOCUMENT_RETRIEVAL_FAILURE: BRIGHTCOVE_ERROR_BASE + 0x01,

  /**
   * Indicates VMAP document parsing failure.
   */
  VMAP_DOCUMENT_PARSING_FAILURE: BRIGHTCOVE_ERROR_BASE + 0x02,
});
